let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1VKrd")).then(() => parcelRequire('6rnVg'));